import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { Calendar as CalendarIkon, ChevronDown } from 'lucide-react';
import { DayPicker } from 'react-day-picker';
import { tr } from 'date-fns/locale';
import { cn } from './cn.js';
import 'react-day-picker/style.css';
const ON_AYARLAR = [
    {
        etiket: 'Bugün',
        hesapla: () => {
            const s = new Date();
            s.setHours(0, 0, 0, 0);
            const e = new Date();
            e.setHours(23, 59, 59, 999);
            return { baslangic: s, bitis: e };
        },
    },
    {
        etiket: 'Dün',
        hesapla: () => {
            const s = new Date();
            s.setDate(s.getDate() - 1);
            s.setHours(0, 0, 0, 0);
            const e = new Date(s);
            e.setHours(23, 59, 59, 999);
            return { baslangic: s, bitis: e };
        },
    },
    {
        etiket: 'Son 7 gün',
        hesapla: () => {
            const e = new Date();
            const s = new Date();
            s.setDate(s.getDate() - 6);
            s.setHours(0, 0, 0, 0);
            return { baslangic: s, bitis: e };
        },
    },
    {
        etiket: 'Son 30 gün',
        hesapla: () => {
            const e = new Date();
            const s = new Date();
            s.setDate(s.getDate() - 29);
            s.setHours(0, 0, 0, 0);
            return { baslangic: s, bitis: e };
        },
    },
    {
        etiket: 'Son 3 ay',
        hesapla: () => {
            const e = new Date();
            const s = new Date();
            s.setMonth(s.getMonth() - 3);
            s.setHours(0, 0, 0, 0);
            return { baslangic: s, bitis: e };
        },
    },
    {
        etiket: 'Bu yıl',
        hesapla: () => {
            const yil = new Date().getFullYear();
            return {
                baslangic: new Date(yil, 0, 1),
                bitis: new Date(yil, 11, 31, 23, 59, 59),
            };
        },
    },
];
function bicim(d) {
    if (!d)
        return '';
    return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric' });
}
export function TarihAraligiSecici({ deger, onDegisim, etiketYok, className, }) {
    const [acik, setAcik] = useState(false);
    const baslik = deger.baslangic
        ? deger.bitis
            ? `${bicim(deger.baslangic)} → ${bicim(deger.bitis)}`
            : bicim(deger.baslangic)
        : 'Tarih aralığı';
    return (_jsxs(Popover.Root, { open: acik, onOpenChange: setAcik, children: [_jsx(Popover.Trigger, { asChild: true, children: _jsxs("button", { type: "button", className: cn('border-fume-200 hover:bg-fume-50 focus:ring-marka-500 dark:border-fume-700 dark:bg-fume-900 dark:hover:bg-fume-800 dark:text-fume-100 inline-flex h-11 items-center gap-2 rounded-lg border bg-white px-3 text-sm transition-colors focus:outline-none focus:ring-2', className), children: [_jsx(CalendarIkon, { size: 14, className: "text-fume-400" }), !etiketYok && _jsx("span", { className: "text-fume-500", children: "Tarih:" }), _jsx("span", { className: "font-medium", children: baslik }), _jsx(ChevronDown, { size: 14, className: "text-fume-400" })] }) }), _jsx(Popover.Portal, { children: _jsxs(Popover.Content, { sideOffset: 6, align: "end", className: "border-fume-200 dark:border-fume-800 dark:bg-fume-900 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 z-50 flex w-auto flex-col gap-3 rounded-2xl border bg-white p-3 shadow-xl sm:flex-row", children: [_jsxs("div", { className: "sm:border-fume-100 dark:sm:border-fume-800 flex flex-col gap-1 sm:w-44 sm:border-r sm:pr-3", children: [ON_AYARLAR.map((p) => (_jsx("button", { type: "button", className: "text-fume-700 hover:bg-fume-100 dark:text-fume-200 dark:hover:bg-fume-800 rounded-md px-2.5 py-1.5 text-left text-sm transition-colors", onClick: () => {
                                        const a = p.hesapla();
                                        onDegisim(a);
                                        setAcik(false);
                                    }, children: p.etiket }, p.etiket))), _jsx("button", { type: "button", className: "text-fume-500 hover:bg-fume-100 dark:hover:bg-fume-800 mt-1 rounded-md px-2.5 py-1.5 text-left text-sm transition-colors", onClick: () => {
                                        onDegisim({});
                                        setAcik(false);
                                    }, children: "Temizle" })] }), _jsx(DayPicker, { mode: "range", locale: tr, numberOfMonths: 1, selected: { from: deger.baslangic, to: deger.bitis }, onSelect: (yeni) => {
                                if (!yeni) {
                                    onDegisim({});
                                    return;
                                }
                                onDegisim({ baslangic: yeni.from, bitis: yeni.to });
                            }, className: "emanetx-takvim", classNames: {
                                today: 'font-bold text-marka-600',
                                selected: 'bg-marka-500 text-fume-900 hover:bg-marka-600',
                                range_start: 'rounded-l-md bg-marka-500 text-fume-900',
                                range_end: 'rounded-r-md bg-marka-500 text-fume-900',
                                range_middle: 'bg-marka-100 text-fume-800 dark:bg-marka-900/30 dark:text-marka-200',
                            } })] }) })] }));
}
/** dateRange → "2026-05-15T00:00:00.000Z" gibi ISO çevirici (API sorgu icin). */
export function tarihIso(d) {
    return d ? d.toISOString() : undefined;
}
//# sourceMappingURL=tarih-araligi.js.map